/**
 * @description defines routes for the contracts page
 */
import React from 'react';

import ForeignTravel from '@seccon/pages/foreignTravelReport';
import UpdateForeignTravel from '@seccon/pages/foreignTravelReport/update';

export default [
  {
    path: 'foreignTravelReport/create',
    element: (
      <ForeignTravel />
    )
  },
  {
    path: 'foreignTravelReport/update/:reportId',
    element: (
      <UpdateForeignTravel />
    )
  }
];
